// extracted by mini-css-extract-plugin
export var header_text = "Header-module--header_text--Y9gjU";
export var image_container = "Header-module--image_container--QbYwY";
export var text_container = "Header-module--text_container--j-+gB";